(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["size-chart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('size-chart-popup')) {
    customElements.define(
      'size-chart-popup',
      class SizeChartPopup extends HTMLElement {
        connectedCallback() {
          // Hoist to <body> so position:fixed is measured against the viewport even
          // when an ancestor has a CSS transform (which would otherwise trap it).
          if (this.parentElement !== document.body) {
            const id = this.dataset.sectionId;
            if (id) {
              document
                .querySelectorAll('body > size-chart-popup[data-section-id="' + id + '"]')
                .forEach((el) => {
                  if (el !== this) el.remove();
                });
            }
            document.body.appendChild(this);
            return; // connectedCallback runs again after re-parenting
          }

          if (this.initialized) return;
          this.initialized = true;
          this.isOpen = false;

          this.trigger = this.querySelector('.size-chart-float');
          this.modal = this.querySelector('.size-chart-modal');
          if (!this.trigger || !this.modal) return;

          this.closeBtn = this.modal.querySelector('.size-chart-modal__close');
          this.onKeydown = this.onKeydown.bind(this);

          this.trigger.addEventListener('click', () => this.open());
          this.modal.querySelectorAll('[data-size-chart-close]').forEach((el) => {
            el.addEventListener('click', () => this.close());
          });

          // Let external triggers (e.g. the "Size guide" link next to the Size
          // options) open this modal via a [data-size-chart-open] attribute.
          // Bound once at the document level for the whole page.
          if (!SizeChartPopup.delegated) {
            SizeChartPopup.delegated = true;
            document.addEventListener('click', (e) => {
              const trigger = e.target.closest('[data-size-chart-open]');
              if (!trigger) return;
              const popup = document.querySelector('size-chart-popup');
              if (!popup || typeof popup.open !== 'function') return;
              e.preventDefault();
              popup.open();
            });
          }
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.onKeydown);
        }

        open() {
          if (this.isOpen) return;
          this.isOpen = true;
          const sbw = window.innerWidth - document.documentElement.clientWidth;
          document.documentElement.style.setProperty('--size-chart-sbw', sbw + 'px');
          this.modal.classList.add('is-open');
          this.modal.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('size-chart-open');
          document.addEventListener('keydown', this.onKeydown);
          if (this.closeBtn) this.closeBtn.focus();
        }

        close() {
          if (!this.isOpen) return;
          this.isOpen = false;
          this.modal.classList.remove('is-open');
          this.modal.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('size-chart-open');
          document.documentElement.style.removeProperty('--size-chart-sbw');
          document.removeEventListener('keydown', this.onKeydown);
          if (this.trigger) this.trigger.focus();
        }

        onKeydown(e) {
          if (e.key === 'Escape' || e.key === 'Esc') this.close();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
